import React from 'react';
import { FormikProps } from 'formik';
import { RelationshipsProps } from '../../models/account-info-epi-props';
import { DividerSection } from '../../../../global/components/layout/divider-section';
import { MailingAddressFieldNames } from '../../models/form-models';
import { AddressField } from '../../../../global/components/form-element/address';
import { getAddressLabels } from '../../selectors/form-selectors';
import { MaritalStatusFormValues, MaritalStatusMailingAddressRequiredSchema } from './marital-form-models';
import { LabelSettingProps } from '../../../../global/models/epi-model';
import { BasicInfo } from '../personal-info/basic-info';
import { PhoneInfo } from '../personal-info/phone-info';
import { EmailInfo } from '../personal-info/email-info';
import { Person } from '../../../../global/models/person-model';

interface Props {
	labelSetting: LabelSettingProps;
	relationshipsProps: RelationshipsProps;
	formProps: FormikProps<MaritalStatusFormValues>;
	spouseIsClergy: boolean;
	addressExpired: boolean;
	addressExpiredError: boolean;
	setAddressExpiredError: (value: boolean) => void;
	docUpload: boolean;
	currentPerson: Person;
	plusSixtyFive?: boolean;
}
export function MaritalStatusMarriedFields(props: Props) {

	const { labelSetting, formProps, spouseIsClergy, relationshipsProps, addressExpiredError, setAddressExpiredError, addressExpired, docUpload, currentPerson, plusSixtyFive } = props;

	return (

		<>
			<DividerSection sectionText={relationshipsProps.spouseInformationSectionLabel}>
				<BasicInfo
					labelSetting={labelSetting}
					formikProps={formProps}
					salutationRequired={spouseIsClergy}
					currentPerson={currentPerson}
					docUpload={docUpload}
					plusSixtyFive={plusSixtyFive}
				/>
			</DividerSection>
			<DividerSection sectionText={props.labelSetting.mailingAddressTitle}>
				<AddressField
					currentCountry={formProps.values.mailing_country === '' ? 'US' : formProps.values.mailing_country}
					labels={getAddressLabels(props.labelSetting)}
					addressFieldNames={MailingAddressFieldNames}
					requiredSchema={MaritalStatusMailingAddressRequiredSchema}
					formProps={formProps}
					addressExpired={addressExpired}
					addressExpiredError={addressExpiredError}
					expiredAddressChangeToggle={(hasChanged: boolean) => setAddressExpiredError(!hasChanged)}
				/>
			</ DividerSection>
			<PhoneInfo
				labelSetting={labelSetting}
				formProps={formProps}
				hideBusiness
			/>
			<EmailInfo
				labelSetting={labelSetting}
				formProps={formProps}
				removeDivider
				hideBusiness
			/>
		</>
	);
}

MaritalStatusMarriedFields.defaultProps = {
	plusSixtyFive: false,
};